import { t } from "i18next";
import { useRef } from "react";

function IFrameWindow(props) {
    const iframeRef = useRef(null);
    
    const handleLoad = () => {
        const userId = sessionStorage.getItem("userId");
        const token = sessionStorage.getItem("jwtKey");
        if (iframeRef.current && userId) {
            try {
                const urlObj = new URL(props.productUrl);
                const targetOrigin = urlObj.origin; 
                
                iframeRef.current.contentWindow.postMessage(
                    { type: 'SET_USER_ID', payload: userId, token: token }, 
                    targetOrigin
                );
            } catch (e) {
                iframeRef.current.contentWindow.postMessage(
                    { type: 'SET_USER_ID', payload: userId, token: token }, 
                    '*'
                );
            }
        }
    };

    return (
        <div style={{height:"100%", margin:0}}>
            <iframe 
                ref={iframeRef}
                onLoad={handleLoad}
                src={props.productUrl} 
                width="100%" 
                height="100%" 
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"
                allowtransparency="true"
                title="3D Product Viewer"
            ></iframe>
        </div>
    )
}
export default IFrameWindow;
